import Link from 'api/models/Engines/Link';

const dataToCopyTextMapper = (data: Link) => {
	return data;
};

export default dataToCopyTextMapper;
